import React, { FC } from 'react';
import {
  Col,
} from 'antd';
import { useTranslation } from 'react-i18next';
import FixWidthContent from '../../components/FixWidthContent';
import classes from './TermsAndConditionsView.module.less';
import withTagManager from '../../hooks/withTagManager';

const PARTS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];

const TermsAndConditionsView: FC = () => {
  const { t } = useTranslation();

  return (
    <FixWidthContent>
      <Col span={24}>
        <h1 className={classes.title}>{t('common:terms.title')}</h1>
        <div className={classes.subContent}>
          {
                PARTS.map((part) => (
                  <>
                    <h3 className={classes.subTitle}>{t(`common:terms.parts.${part}.title`)}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t(`common:terms.parts.${part}.content`) }} />
                  </>
                ))
            }
        </div>
      </Col>
    </FixWidthContent>
  );
};

export default withTagManager(TermsAndConditionsView);
